export default "__VITE_ASSET__DSmNP$BR__"